import { useState } from "react";
import Image from "next/image";
import styles from "./choose.module.css";
import AOS from "aos";
import "aos/dist/aos.css";
import CountUp from "react-countup";
import { useEffect } from 'react'
import { useRouter } from "next/router";
//import icon1 from "../../assets/images/home/newicon/icon-1.png";
// import icon2 from "../../assets/images/home/newicon/icon-2.png";
// import icon3 from "../../assets/images/home/newicon/icon-3.png";

const WhyChooseUs = () => {

  const items = [
    {
      title: "Highlights of TNPSC Group I Main Test Series",
      content: [
        "All the tests will be conducted for 250 marks.",
        "Question Paper cum Answer booklet will be provided only in Printed format.",
        
      ],
      more: [
        "Question papers based on the dynamics of TNPSC.",
        "Our test series is a real simulation of the TNPSC Group I Main exam.",
        "Explanatory Materials for Unit Tests in Bilingual (Soft Copy).",
        "Printed answer-booklets of SIA’s 2022 cleared candidates (Issued for both offline & online students in book format)",
        "Recorded Orientation/Discussion Videos.(For further reference)",
        "Printed answer booklets of cleared candidates",
        "8*7 Individual Mentoring by Expert Team (Only at SIA Branches)",
        "Z+ Series – Group I Mains Current Affairs Material (Zero Current Affairs for Mains)",
        "Z+ Series – Crash Course for Main Current Affairs (For both offline and online students)",
        "Skill Up Junction” - Motivational Session (By SIA’s Cleared Candidates periodically)",
        "Mentoring Carnival for Online and SIA Branch Students",
        "We will conduct a Doubt Clearing Session.",
        "Value Addition Lecture Series (Only for Test Batch Students – on most important topics)"

      ],
      aos: "fade-down",
      

    },
    {
      title: "Highlights of TNPSC Group II/IIA Test Series",
      content: [
        "All the tests will be conducted for 300 marks",
        "Question Paper cum Answer booklet will be provided only in Printed format",
        

      ],
      more: [
        "Question papers based on the dynamics of TNPSC.",
        "Our test series is a real simulation of the TNPSC Group II/IIA Main exam",
        "Our test series covers the syllabus holistically.",
        "Provides platform for State Level Analysis of performance and improve your competency.",
        "Flexible for working candidates to take the test as per their availability.",
        "Special Focus will be given for Unit II, III, IV and V.",
        "Explanatory notes for all Tests (Except Mock Tests) will be provided in bilingual mode. Shankar IAS Academy is the only institute that provides such facility."
      ],
      aos: "fade-down",
    },
    {
      title: "Prelims Test Series",
      content: [
        "Our test series is a real simulation of the TNPSC Group I Prelims exam.",
        "Our test series covers the syllabus holistically.",
        

      ],
      more: [
        "Our test series is based on the dynamism of TNPSC",
        "All the tests will be conducted for 200 questions only",
        "We do post test discussion analysis on the perspective of difficulty level, conceptual level, Current Event level, etc.,",
        "Recorded post test discussion analysis will be provided for further reference.",
        "Recorded discussions",
        "Provides a platform for State Level Analysis of performance and improves your competency.",
        "Flexible for working candidates to take the test as per their availability."
      ],
      aos: "fade-down",
    },

    {
      title: "Interview Guidance",
      content: [
        "Free Interview classes.",
        "Individual attention."
      ],
      more: [
        "Mock Interview by serving bureaucrats and others.",
        "Mock Interview will be recorded and analysis will be shared for further enhancement.",
       
      ],
      aos: "fade-down",
    }
  ];

   const router = useRouter();
   
   useEffect(() => {
     AOS.init({
       duration: 800,
       easing: "ease-in-out",
       once: true,
       offset: 100,
     });
   }, []);

  return (
    <div   className={styles.wrapper}>
      <h1 className={styles.sectionTitle}>
        Most Trusted Test Series & Mains Crash Course
      </h1>
      <div className={styles.grid}>
        {items.map((item, index) => ( 
        <div key={index} className={styles.cardWrapper} data-aos={item.aos}>
          <div className={styles.card}>
               <h5 className={styles.cardTitle}>{item.title}</h5>
              <div className={styles.content}>
                {item.content.map((text, i) => (
                  <p key={i}>{text}</p>
                ))}
              </div>

              <div className={styles.readMore}>Read More</div>

              <div className={styles.more}>
                <ul>
                  {item.more.map((point, i) => (
                    <li key={i}>{point}</li>
                  ))}
                </ul>
              </div>
          </div>
        </div>
        ))}
      </div>
    </div>
  );
};




export default WhyChooseUs;
